import { render } from "./ApprovalReturnRequest.vue?vue&type=template&id=73d14c68&scoped=true"
import script from "./ApprovalReturnRequest.vue?vue&type=script&lang=js"
export * from "./ApprovalReturnRequest.vue?vue&type=script&lang=js"

import "./ApprovalReturnRequest.vue?vue&type=style&index=0&id=73d14c68&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d14c68"]])

export default __exports__